export const TRAY_TITLE = 'title';
export const TRAY_SUBTITLE = 'subtitle';
export const TRAY_CAPTION = 'caption';
